export default __webpack_public_path__ + "static/media/topSmallExplorerBackground.06d138a5.jpg";